module.exports = __webpack_public_path__ + "img/liucheng@2x.422d8bce.png";